import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom"; 
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify"; 
import "./style.css"; 

import Login from "./Auth/Login";
import OtpVerification from "./Auth/OtpVerification";
import ForgotPassword from "./Auth/ForgotPassword";
import Registration from "./Auth/Registration";
import Logout from "./Auth/Logout";
import Profile from "./Music/profile";
import LandingPage from "./Music/landing";
import Landings from "./Auth/Landings";
import MusicManager from "./Music/musicmanager";
import CategoryManager from "./Music/categorymanager";
import AdminPage from "./Music/adminpage";
import SocialMediaManager from "./Music/socialmedia";
import GuestLandingPage from "./Music/guest";
import PromoCodesPage from "./Music/promocode";


function App() {
  return (
    <Router>
      <Routes>
        {/* ── Public Routes ─────────────────────────────────────────── */}
        <Route path="/" element={<Landings />} />
        <Route path="/OtpVerification" element={<OtpVerification />} />
        <Route path="/Registration" element={<Registration />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/logout" element={<Logout />} />

        <Route path="/guest" element={<GuestLandingPage />} />

        <Route 
          path="/login" 
          element={
              <Login />
          } 
        />

        {/* ── Authenticated Routes (Any logged-in user) ─────────────── */}
        <Route 
          path="/music/landing" 
          element={
            <TokenGuard>
              <AuthGuard>
                <LandingPage />
              </AuthGuard>
            </TokenGuard>
          } 
        />
        <Route 
          path="/music/profile" 
          element={
            <TokenGuard>
              <AuthGuard>
                <Profile />
              </AuthGuard>
            </TokenGuard>
          } 
        />

        <Route 
  path="/music/adminpage" 
  element={
    <AdminGuard>
      <AdminPage />
    </AdminGuard>
  } 
/>

        {/* ── Admin Only Routes ─────────────────────────────────────── */}
        <Route 
          path="/music/musicmanager" 
          element={
            <AdminGuard>
              <MusicManager />
            </AdminGuard>
          } 
        />
        <Route 
          path="/music/categorymanager" 
          element={
            <AdminGuard>
              <CategoryManager />
            </AdminGuard>
          } 
        />
        <Route path="/music/promocode" element={
            <AdminGuard>
              <PromoCodesPage />
            </AdminGuard>
          } />
        <Route 
          path="/music/socialmedia" 
          element={
            <AdminGuard>
              <SocialMediaManager />
            </AdminGuard>
          } 
        />

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <ToastContainer />
    </Router>
  );
}

export default App;


// ─── Guards ─────────────────────────────────────────────────────────────

export function AuthGuard({ children }) {
  const navigate = useNavigate();
  useEffect(() => {
    const userDataString = localStorage.getItem("user");
    try {
      const userData = JSON.parse(userDataString);
      const userId = userData?.unique;
      if (!userId) {
        navigate("/");
      }
    } catch (error) {
      navigate("/");
    }
  }, [navigate]);

  return <>{children}</>;
}

export function TokenGuard({ children }) {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    }
  }, [navigate]);

  return <>{children}</>;
}

// NEW: Admin Guard strictly for 'ADMIN' role
export function AdminGuard({ children }) {
  const navigate = useNavigate();
  
  useEffect(() => {
    const token = localStorage.getItem("token");
    const userDataString = localStorage.getItem("user");

    // 1. If not logged in at all, kick to login
    if (!token || !userDataString) {
      navigate("/");
      return;
    }

    try {
      const userData = JSON.parse(userDataString);
      
      // 2. Check if the user is an Admin
      // Make sure the property matches exactly what your backend sends (e.g., 'role', 'Role')
      if (userData?.role !== "ADMIN") {
        // Kick non-admins back to the landing page
        navigate("/music/landing");
      }
    } catch (error) {
      console.error("AdminGuard Error:", error);
      navigate("/");
    }
  }, [navigate]);

  return <>{children}</>;
}